import * as VueGoogleMaps from 'vue2-google-maps';

var lodash = require('lodash');
var Vue = require('vue');
var jQuery = require('jquery');
import {
    Navbar, FormGroup, FormInput, InputGroup,
    FormSelect, FormCheckbox, Pagination,
} from 'bootstrap-vue/es/components';

// import VueRouter from 'vue-router'
import env from '../../cms/js/config/base';
import Notifications from 'vue-notification';
import getHelpers from './helpers';

var bootstrapdatetimepicker = require('bootstrap-datetimepicker-npm');

import main from './store/main';

var _ = lodash;
window._ = _;
window.lodash = lodash;

Vue.use(Vuex);
Vue.use(Navbar);
Vue.use(FormGroup);
Vue.use(FormInput);
Vue.use(InputGroup);
Vue.use(FormSelect);
Vue.use(FormCheckbox);
Vue.use(Pagination);
// Vue.use(VueRouter);

Vue.set(Vue.prototype, 'helpers', getHelpers(env));
Vue.set(Vue.prototype, '_', _);

var store = new Vuex.Store(main);
window.store = store;
window.mountVueComponent = (id, component) => {
    var root = document.getElementById(id);
    if (root) {
        var data = null;
        var config = null;

        try {
            var content = root.textContent;
            content = JSON.parse(content);
            data = content.data || null;
            config = content.config || null;

        } catch (e) {
            console.info(`Problem parsing data and config for component ${id}`);
        }

        Vue.use(VueGoogleMaps, {
            load: {
                key: window.env.GOOGLE_MAP_KEY,
                libraries: "places" // necessary for places input
            }
        });

        new Vue({
            el: root,
            store,
            render: h => h(component, {
                props: { initialData: data, config }
            }),
        })
    }
}

window.dispatchEvent(new CustomEvent('vue-init'));

_.chain(document.querySelectorAll('script[data-src]'))
    .map((el) => {
        el.src = el.dataset.src;
    })
    .value();


// WEBPACK FOOTER //
// ./resources/assets/site/js/vue-init.js